import React from 'react'
import PropTypes from 'prop-types'

const CompanySection = ({ title, data, address }) => (

  <div>
    <h4>{title}</h4>
    <table className='mt-3 mb-3'>
      <tbody>
        {data.company
                    ? <tr>
                      <td className='td_label'>Company:</td>
                      <td>{data.company}</td>
                    </tr>
                : null}
        {data.name
                    ? <tr>
                      <td className='td_label'>Name:</td>
                      <td>{data.first_name} {data.last_name}</td>
                    </tr>
                : null}
        {data.street && address
                    ? <tr>
                      <td className='td_label'>Street:</td>
                      <td>{data.street}</td>
                    </tr> : null}
        {data.city && address
                  ? <tr>
                    <td className='td_label'>Town:</td>
                    <td>{data.city}</td>
                  </tr> : null}
        {data.zip && address
                    ? <tr>
                      <td className='td_label'>ZIP:</td>
                      <td>{data.zip}</td>
                    </tr> : null}
        {data.business_id
                    ? <tr>
                      <td className='td_label'>Identification number:</td>
                      <td>{data.business_id}</td>
                    </tr>
                : null}
        {data.tax_id
                    ? <tr>
                      <td className='td_label'>Tax number:</td>
                      <td>{data.tax_id}</td>
                    </tr>
                : null}
        {data.vat_id
                    ? <tr>
                      <td className='td_label'>VAT number:</td>
                      <td>{data.vat_id}</td>
                    </tr>
                : null}
      </tbody>
    </table>
  </div>
)

CompanySection.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  address: PropTypes.bool
}

export default CompanySection



// WEBPACK FOOTER //
// ./src/molecules/components/CompanySection.js